import { Place } from "@/types";

import { motion } from "framer-motion";
import { tabVariantsAnimation } from "@/theme/theme";
import InfoBlock from "@/components/InfoBlock";

interface PageProps {
    place: Place;
}
const Info: React.FC<PageProps> = ({ place }) => {
    const { data } = place;
    return (
        <motion.div
            variants={tabVariantsAnimation}
            animate="animate"
            initial="initial"
            className="flex max-lg:flex-col-reverse gap-4 "
        >
            <div
                className="basis-3/5"
                dangerouslySetInnerHTML={{ __html: data?.content }}
            />
            <InfoBlock data={data} />
        </motion.div>
    );
};

export default Info;
